import {
  QueryMode,
  SortDirection,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { useVenueListLazyQuery } from "@ticketingplatform/api/dist/venue";
import useAutoComplete from "hooks/useAutoComplete";
import { useCallback } from "react";
import { Venue } from "@ticketingplatform/api/dist/venue/__generated__/fragments";
import type { GetOptionLabel } from "react-select";

import { UseVenueSelect } from "./types";

export const useVenueSelect: UseVenueSelect = (props) => {
  const [fetchVenues] = useVenueListLazyQuery();

  return useAutoComplete<Venue, false>({
    ...props,
    defaultOptions: true,
    getOptionLabel: useCallback<GetOptionLabel<Venue>>(
      (venue) => venue.name,
      []
    ),
    loadOptions: useCallback(
      async (search: string) => {
        const { data } = await fetchVenues({
          variables: {
            addressInclude: false,
            organizationInclude: false,
            orderBy: [{ name: SortDirection.asc }],
            take: 10,
            filters: search
              ? {
                  name: {
                    contains: search,
                    mode: QueryMode.insensitive,
                  },
                }
              : undefined,
          },
        });

        return data?.venues?.nodes ?? [];
      },
      [fetchVenues]
    ),
  });
};
